import { useEffect, useState } from "react";
import api from "@/lib/api";

export const DEFAULT_NAV = [
  { label: "Office Space", to: "/office-space" },
  { label: "Locations", to: "/locations" },
  { label: "Pricing", to: "/pricing" },
  { label: "Amenities", to: "/amenities" },
  { label: "About", to: "/about-us" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const DEFAULT_FOOTER_COLUMNS = [
  { title: "Workspaces", links: [
    { label: "Private Offices", to: "/workspaces/private-offices" },
    { label: "Dedicated Desks", to: "/workspaces/dedicated-desks" },
    { label: "Meeting & Conference Rooms", to: "/workspaces/meeting-conference-rooms" },
    { label: "Training Rooms", to: "/workspaces/training-rooms" },
  ] },
  { title: "Locations", links: [
    { label: "The iThum, Sector 62", to: "/locations/the-ithum" },
    { label: "Bhutani Cyber Park", to: "/locations/bhutani-cyber-park" },
    { label: "Alphathum, Sector 90", to: "/locations/alphathum-towers" },
    { label: "View All Locations", to: "/locations" },
  ] },
  { title: "Company", links: [
    { label: "About Us", to: "/about" },
    { label: "Blog", to: "/blog" },
    { label: "Partner With Us", to: "/property-owners" },
    { label: "Careers", to: "/careers" },
    { label: "Contact", to: "/contact" },
  ] },
  { title: "Support", links: [
    { label: "FAQs", to: "/about" },
    { label: "Terms of Use", to: "/terms-of-use" },
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Sitemap", to: "/api/seo/sitemap.xml" },
  ] },
];

export const DEFAULT_FOOTER_CONTACTS = [
  { icon: "phone", label: "+91-9289179189", href: "tel:+919289179189" },
  { icon: "whatsapp", label: "+91-9953010006", href: "https://wa.me/919953010006" },
];

export const DEFAULT_SEO_FOOTER = {
  enabled: true,
  eyebrow: "Explore by location",
  heading: "Coworking Spaces in Noida",
  subheading: "Find the right workspace in your preferred area. Explore our spaces across key sectors in Noida.",
  columns: [
    {
      id: "sector-62", enabled: true, eyebrow: "Popular location",
      title: "Coworking Space in Sector 62",
      description: "Premium coworking spaces in Noida Sector 62 with excellent connectivity and modern amenities.",
      image: "https://images.unsplash.com/photo-1554469384-e58fac16e23a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      links: [
        { id: "s62-cowork", enabled: true, label: "Coworking Space in Sector 62", url: "/workspaces/dedicated-desks", target: "_self" },
        { id: "s62-managed", enabled: true, label: "Managed Office in Sector 62", url: "/workspaces/private-offices", target: "_self" },
        { id: "s62-meeting", enabled: true, label: "Meeting Rooms in Sector 62", url: "/workspaces/meeting-conference-rooms", target: "_self" },
        { id: "s62-training", enabled: true, label: "Training Rooms in Sector 62", url: "/workspaces/training-rooms", target: "_self" },
      ],
    },
    {
      id: "noida-expressway", enabled: true, eyebrow: "Fast growing business hub",
      title: "Coworking Space on Noida Expressway",
      description: "Flexible workspaces on Noida Expressway with easy access to major business hubs.",
      image: "https://images.unsplash.com/photo-1708357453136-f9260ac62260?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      links: [
        { id: "exp-cowork", enabled: true, label: "Coworking Space on Expressway", url: "/workspaces/dedicated-desks", target: "_self" },
        { id: "exp-managed", enabled: true, label: "Managed Office on Expressway", url: "/workspaces/private-offices", target: "_self" },
        { id: "exp-meeting", enabled: true, label: "Meeting Rooms on Expressway", url: "/workspaces/meeting-conference-rooms", target: "_self" },
        { id: "exp-training", enabled: true, label: "Training Rooms on Expressway", url: "/workspaces/training-rooms", target: "_self" },
      ],
    },
  ],
};

let _cache = null;
let _inflight = null;

export function useSiteConfig() {
  const [cfg, setCfg] = useState(_cache);
  useEffect(() => {
    if (_cache) { setCfg(_cache); return; }
    if (!_inflight) {
      _inflight = api.get("/public/site-config").then((r) => { _cache = r.data; return r.data; }).catch(() => ({}));
    }
    _inflight.then((d) => setCfg(d));
  }, []);
  return cfg || {};
}
